import {getRequiredValidations, ValidYamlConstraint} from '@hit/components';
import {required} from '@vuelidate/validators';
// FormUtils must not import the @hit/base barrel (see FormUtils DataService deep import).
import {isValidSectionsYaml} from 'hit-online-web-ui/src/views/form/FormUtils';

function getFormValidations() {
  return {
    formDefinition: getRequiredValidations(),
  };
}

function getFormDefinitionValidations({
  languages,
  editorLanguage,
  getLocalizedFieldFn: _getLocalizedFieldFn,
} = {}) {
  let validations = {
    active: {},
    definition: {isValidSectionsYaml},
  };
  languages.forEach((language) => {
    let languageFiltered = language.replace('-', '').replace('_', '');
    let languageCamelCase =
      languageFiltered[0].toUpperCase() +
      languageFiltered[1].toLowerCase() +
      languageFiltered[2].toUpperCase() +
      languageFiltered[3].toLowerCase();
    validations['designation' + languageCamelCase] = {required};
  });

  if (editorLanguage === 'yaml') {
    new ValidYamlConstraint(true).addToValidator(validations.definition);
  }

  return validations;
}

export {getFormValidations, getFormDefinitionValidations};
